export default {"src":"/_next/static/media/grt.d727e855.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};